<template>
  <div style="width: 100%;height: 100%;">
    <!-- viewBox="0 0 900 900" -->
    <svg t="1677572587600" viewBox="0 0 1024 1024" class="icon"
      version="1.1" 
     xmlns="http://www.w3.org/2000/svg"
      p-id="8856" width="100%" height="100%">
      <path d="M917.333333 938.666667h-21.333333V96a53.393333 53.393333 0 0 0-53.333333-53.333333H181.333333a53.393333 53.393333 0 0 0-53.333333 53.333333v842.666667h-21.333333a21.333333 21.333333 0 0 0 0 42.666666h810.666666a21.333333 21.333333 0 0 0 0-42.666666z m-661.333333 0V170.666667h512v277.333333a21.333333 21.333333 0 0 0 42.666667 0V149.333333a21.333333 21.333333 0 0 0-21.333334-21.333333H234.666667a21.333333 21.333333 0 0 0-21.333334 21.333333v789.333334h-42.666666V96a10.666667 10.666667 0 0 1 10.666666-10.666667h661.333334a10.666667 10.666667 0 0 1 10.666666 10.666667v842.666667z m554.666667-320v256a21.333333 21.333333 0 0 1-42.666667 0V618.666667a21.333333 21.333333 0 0 1 42.666667 0z m0-85.333334a21.333333 21.333333 0 0 1-21.333334 21.333334H661.333333a21.333333 21.333333 0 0 1 0-42.666667h128a21.333333 21.333333 0 0 1 21.333334 21.333333z"
       :fill="borderColor" p-id="8857"></path></svg>
  </div>
</template>

<script>
export default {
  inject:['getNode'],
  data() {
    return {
      borderColor: 'rgb(151, 151, 151)',
    };
  },
  mounted(){
    const node = this.getNode();
    node.on('change:data',(res)=>{
      console.log("数据发生改变",res)
      this.borderColor = res.current.borderColor;
    })
  }
};
</script>

<style>

</style>